import { useSuspenseQuery } from '@apollo/client';
import {
  ListMattersByClientDocument,
  ListMattersByRecentDocument,
} from '__generated__/graphql';

export function useMatters(mostRecent: boolean) {
  const {
    data: { matterServiceMatters },
  } = useSuspenseQuery(
    mostRecent ? ListMattersByRecentDocument : ListMattersByClientDocument,
  );

  return matterServiceMatters;
}

export const refetchListMatters = [
  { query: ListMattersByClientDocument },
  { query: ListMattersByRecentDocument },
];
